import { SourcesEventType } from '@photosi/rn-components/modals/dynamic-modals/modal-upload-multisource/ModalUploadMultisource.constants';
import { SELECTED_MENU_ITEMS } from 'src/store/_models/dynamic-modal-layer/dynamicModalLayer.constants';

export const getSourceType = (source: SELECTED_MENU_ITEMS) => {
  switch (source) {
    case SELECTED_MENU_ITEMS.Computer:
      return SourcesEventType.Computer;
    case SELECTED_MENU_ITEMS.Gallery:
      return SourcesEventType.Gallery;
    case SELECTED_MENU_ITEMS.GooglePhoto:
      return SourcesEventType.GooglePhoto;
    case SELECTED_MENU_ITEMS.Smartphone:
      return SourcesEventType.Smartphone;
    case SELECTED_MENU_ITEMS.FamilyFriends:
      return SourcesEventType.FamilyFriends;
    default:
      return '';
  }
};
